import React from 'react';
import { Typography, Card, CardHeader, CardContent, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import ChangeChip from './ChangeChip';
import RichTooltip from '../RichTooltip';
import RenderPeriodDateRange from '../account/reportingPeriod/RenderPeriodDateRange';
import FluidValue from './FluidValue';

const Action = ({ explanation, showChangeChip, a, b }) => {
    if (explanation === null) {
        if (!showChangeChip) {
            return null;
        }

        return (
            <ChangeChip
                change={b - a}
                a={a}
                b={b}
            />
        );
    }
    else {
        if (!showChangeChip) {
            return (
                <RichTooltip>
                    {explanation}
                </RichTooltip>
            );
        }

        return (
            <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
                <RichTooltip>
                    {explanation}
                </RichTooltip>
                <ChangeChip
                    change={b - a}
                    a={a}
                    b={b}
                />
            </Stack>
        );
    }
};

const CompareValues = ({ a, b, showB, text, icon, periodColours, selectedPeriods, valueType = 'number', showChange = true, accuracy = null, explanation = null, noDataA = false, noDataB = false }) => {
    const theme = useTheme();

    const showChangeChip = showChange && showB && valueType !== 'hour';

    return (
        <Card sx={{ height: '100%' }}>
            <CardHeader
                avatar={icon}
                title={text}
                slotProps={{
                    title: {
                        variant: 'body1'
                    }
                }}
                sx={{
                    m: 0,
                    p: 1,
                    '& .MuiCardHeader-action': {
                        m: 0
                    },
                    '& .MuiCardHeader-avatar': {
                        mr: 1
                    }
                }}
                action={(
                    <Action
                        showChangeChip={showChangeChip}
                        explanation={explanation}
                        a={a}
                        b={b}
                    />
                )}
            />
            <CardContent
                sx={{
                    m: 0,
                    px: 2,
                    pt: 0,
                    pb: 2,
                    '&:last-child': {
                        paddingBottom: 2
                    }
                }}
            >
                <Grid container spacing={1}>
                    <Grid
                        sx={{ textAlign: 'center' }}
                        size={{
                            xs: 12,
                            sm: showB ? 6 : 12
                        }}
                    >
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                            {showB ? 'Period A:' : (
                                <RenderPeriodDateRange
                                    period={selectedPeriods ? selectedPeriods[0] : null}
                                />
                            )}
                        </Typography>
                        <FluidValue
                            typographyVariant="h5"
                            colour={periodColours[0]}
                            value={a}
                            valueType={valueType}
                            accuracy={accuracy}
                            noData={noDataA}
                        />
                    </Grid>
                    {showB && (
                        <Grid
                            sx={{ textAlign: 'center' }}
                            size={{
                                xs: 12,
                                sm: 6
                            }}
                        >
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                Period B:
                            </Typography>
                            <FluidValue
                                typographyVariant="h5"
                                colour={periodColours[1]}
                                value={b}
                                valueType={valueType}
                                accuracy={accuracy}
                                noData={noDataB}
                            />
                        </Grid>
                    )}
                </Grid>
            </CardContent>
        </Card>
    );
};

export default CompareValues;